/* MMS custom overall length — cart-side sync (CUSTLEN 2026-07-15).
   Keeps the hidden "Custom Length — Per Foot" add-on line consistent with its
   strap line (linked by the _custlen_key / _custlen_for properties written by
   snippets/mms-custom-length.liquid):
     - strap line removed  -> add-on line removed
     - strap line qty changed -> add-on qty = _custlen_perqty x strap qty
     - add-on line removed/edited by hand -> restored to the correct quantity
   One corrective action per pass, then a reload so Shopify re-renders totals.
   Capped at 5 fixes per page view so a failure can never loop. */
(function () {
  'use strict';
  var fixes = 0;
  var MAX_FIXES = 5;

  function jfetch(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error(url + ' -> ' + r.status);
      return r.json();
    });
  }

  function afterFix() { window.location.reload(); }

  function changeLine(lineKey, quantity) {
    if (fixes++ >= MAX_FIXES) return;
    jfetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(afterFix).catch(function () {});
  }

  function addAddon(variantId, quantity, key, strapTitle) {
    if (fixes++ >= MAX_FIXES) return;
    jfetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity, properties: { 'For': strapTitle, '_custlen_for': key } }] })
    }).then(afterFix).catch(function () {});
  }

  function sync() {
    jfetch('/cart.js').then(function (cart) {
      var straps = {};
      var addons = {};
      var i, it, p, key;
      for (i = 0; i < cart.items.length; i++) {
        it = cart.items[i];
        p = it.properties || {};
        if (p._custlen_key) straps[p._custlen_key] = it;
        if (p._custlen_for) addons[p._custlen_for] = it;
      }
      // Orphaned add-on (its strap is gone) -> remove it.
      for (key in addons) {
        if (!Object.prototype.hasOwnProperty.call(addons, key)) continue;
        if (!straps[key]) return changeLine(addons[key].key, 0);
      }
      // Each custom strap: add-on quantity must equal perqty x strap quantity.
      for (key in straps) {
        if (!Object.prototype.hasOwnProperty.call(straps, key)) continue;
        it = straps[key];
        var perqty = parseInt(it.properties._custlen_perqty, 10) || 0;
        var want = perqty * it.quantity;
        var have = addons[key] ? addons[key].quantity : 0;
        if (have === want) continue;
        if (addons[key]) return changeLine(addons[key].key, want);
        var vid = parseInt(it.properties._custlen_addon_variant, 10);
        var label = (it.properties['Custom overall length'] || '').trim();
        if (vid && want > 0) return addAddon(vid, want, key, it.product_title + (label ? ' — custom ' + label : ''));
      }
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  // Dawn publishes cartUpdate after AJAX quantity changes/removals on the cart page.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sync, 300); });
  }
})();
